export function randomColor(){
  return {
    r: Math.floor(Math.random() * 255),
    g: Math.floor(Math.random() * 255),
    b: Math.floor(Math.random() * 255),
    a: 1
  }
}

export function translateRGBAColor(color){
  return color && `rgba(${ color.r }, ${ color.g }, ${ color.b }, ${ color.a })`
}